module.exports = __webpack_public_path__ + "static/media/ttee_hatti_dirgha.fd1b9bd3.ogg";